export default "__VITE_ASSET__q9CSa_EG__"